@if (displayText) {
  <div [class]="className" class="row">
    <div class="col">
      <rs-web-icon [icon]="immomioIconName.Calendar" [size]="16"></rs-web-icon>
      <rs-web-label [text]="displayText" className="body text-secondary"></rs-web-label>
    </div>
  </div>
}
